/* eslint-disable no-unused-vars */

// ----------  Error handeler -----------
export function handleApiError(err, method) {
  throw err?.response
}


export async function processError(error) {
  let apiMessage = null;

  if (error.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      try {
        const json = JSON.parse(text);
        apiMessage = json.message;
      } catch {
        apiMessage = text;
      }
    } catch (e) {
      if (process.env.NODE_ENV === "development" ) {
        console.error("Error processing blob response:", e);
      }
    }
  }

  return (
    apiMessage || error?.response?.data?.message ||
    error?.message ||
    'Unknown error occurred'
  );
}


// ----------  Base function for vuex api  -----------

export async function executeAction({ commit, action }, asyncFn, { success } = {}, isThrowError = true) {

  commit('SET_LOADING', { action, status: true });
  commit('SET_ERROR', { action, message: null });

  try {
    const response = await asyncFn();
    if (success) success(response.data);
    return response.data.data;
  } catch (err) {
    const message =await processError(err);
    commit('SET_ERROR', { action, message });
    if(isThrowError)
      throw err;
  } finally {
    commit('SET_LOADING', { action, status: false });
  }
}

export async function executeDownloadAction({ commit, action }, asyncFn, filename = 'downloaded_file', isThrowError = true) {
  commit('SET_LOADING', { action, status: true });
  commit('SET_ERROR', { action, message: null });

  try {
    const response = await asyncFn();

    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;

    const disposition = response.headers['content-disposition'];
    if (disposition && disposition.includes('filename=')) {
      const match = disposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/i);
      if (match && match[1]) {
        const decodedFilename = decodeURIComponent(match[1].replace(/"/g, ''));
        link.download = decodedFilename;
      } else {
        link.download = filename;
      }
    } else {
      link.download = filename;
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    const message = await processError(err);
    commit('SET_ERROR', { action, message });
    if (isThrowError) throw err;
  } finally {
    commit('SET_LOADING', { action, status: false });
  }
}
